import React, { useCallback, useEffect } from 'react';
import { RadialMenu } from './radialMenu.js';
import { Widget } from '../../pages/UserGroupsPage';
import { RadialMenuDiv } from './styles';
import { useTheme } from '../../context/ThemeContext';

interface props {
  widgets: Widget[];
  setSelectedWidget: Function;
  updateBreadcrumb: Function;
  path: string[];
}

const RadialMenuReact: React.FC<props> = ({
  widgets,
  setSelectedWidget,
  updateBreadcrumb,
  path,
}) => {
  const { isDarkMode } = useTheme();

  const findWidget = useCallback(
    (widgetsList: any[], widgetId: string): any => {
      return widgetsList.reduce((selectedWidget, widget) => {
        if (selectedWidget) return selectedWidget;

        if (widget.widgetId === widgetId) return widget;

        if (widget.children && widget.children.length > 0) {
          return findWidget(widget.children, widgetId);
        }

        return null;
      }, null);
    },
    [],
  );

  const handleClick = useCallback(
    (event: any) => {
      const widgetId = event.id;
      const selectedWidget = findWidget(widgets, widgetId);
      setSelectedWidget(selectedWidget);
    },
    [findWidget, setSelectedWidget, widgets],
  );

  const handleDoubleClick = useCallback(
    (event: any) => {
      const widgetId = event.id;
      const widget = findWidget(widgets, widgetId);
      if (widget && widget.url) {
        window.open(widget.url);
      }
    },
    [findWidget, widgets],
  );

  const handleClose = useCallback(() => {
    setSelectedWidget(undefined);
  }, [setSelectedWidget]);

  const deepSearchMappingWidgets = useCallback((widgetList: any[]) => {
    return widgetList.map((widget: Widget) => {
      const newWidget: any = {
        id: widget.widgetId,
        title: widget.name,
        image: widget.urlImage,
      };

      if (widget.children && widget.children.length > 0) {
        newWidget.items = deepSearchMappingWidgets(widget.children);
      }

      return newWidget;
    });
  }, []);

  useEffect(() => {
    const menuItems = deepSearchMappingWidgets(widgets);

    const change = menuItems.find((widget: any) => {
      return widget.title === 'Change';
    });
    const analytik = menuItems.find((widget: any) => {
      return widget.title === 'Analytik';
    });
    const beratung = menuItems.find((widget: any) => {
      return widget.title === 'Beratung';
    });

    const sortedMenuItens: any = [];
    if (analytik && change && beratung) {
      sortedMenuItens[0] = change;
      sortedMenuItens[1] = analytik;
      sortedMenuItens[2] = beratung;
    } else {
      sortedMenuItens.push(...menuItems);
    }

    const radialMenu = document.getElementById('radialMenu');
    if (radialMenu) {
      radialMenu.innerHTML = '';
      if (widgets.length > 0) {
        const svgMenu = new RadialMenu({
          parent: radialMenu,
          size: 800,
          closeOnClick: true,
          menuItems: sortedMenuItens,
          theme: isDarkMode ? 'dark' : 'light',
          updateBreadcrumb,
          onClick: handleClick,
          handleDoubleClick,
          onClose: handleClose,
        });

        svgMenu.open(path);
      }
    }
  }, [
    deepSearchMappingWidgets,
    handleClick,
    handleClose,
    handleDoubleClick,
    isDarkMode,
    path,
    updateBreadcrumb,
    widgets,
  ]);

  return <RadialMenuDiv id="radialMenu" />;
};

export default RadialMenuReact;
